import { Box, styled } from '@mui/material';

export const StepperContainer = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: unset !important;
  padding-right: unset !important;
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContentWrapper = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const CardGridWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin: 30px 0;
  padding: 3px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ButtonContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid ${theme.palette.divider};
  gap: 16px;
`,
);
